import { AxiosInstance as ApiInstance } from 'axios'

class EvaluacionService {
  API: ApiInstance

  constructor (api: ApiInstance) {
    this.API = api
  }

  async verificarEstado (activityScheduleId: number) {
    try {
      const { data } = await this.API.get(`/api/evaluacion/estado/${activityScheduleId}`)
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response?.data || error.message))
    }
  }

  async iniciar (activityScheduleId: number) {
    try {
      const { data } = await this.API.post(`/api/evaluacion/iniciar/${activityScheduleId}`)
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response?.data || error.message))
    }
  }

  async obtenerPreguntas (reviewsAnswerId: number) {
    try {
      const { data } = await this.API.get(`/api/evaluacion/preguntas/${reviewsAnswerId}`)
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response?.data || error.message))
    }
  }

  async responder (reviewsAnswerId: number, respuestas: Array<{ questionId: number, answerId: number }>, tiempoTranscurrido: string) {
    try {
      const { data } = await this.API.post(`/api/evaluacion/responder/${reviewsAnswerId}`, {
        respuestas,
        tiempoTranscurrido
      })
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response?.data || error.message))
    }
  }

  async consultarResultado (reviewsAnswerId: number) {
    try {
      const { data } = await this.API.get(`/api/evaluacion/resultado/${reviewsAnswerId}`)
      return data
    } catch (error: any) {
      throw new Error(JSON.stringify(error.response?.data || error.message))
    }
  }
}

export default EvaluacionService
